import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const DataHubIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    "data-icon-name": "DataHub",
    viewBox: "0 0 32 32",
    focusable: "false",
    children: /*#__PURE__*/_jsx("path", {
      d: "M13.88 15.443a.29.29 0 0 1 .41.02l1.094 1.122a2.5 2.5 0 0 0 3.383.19c.015-.014.035-.028.05-.043l7.426-6.939c.234.059.479.093.728.093A3.03 3.03 0 0 0 29.93 6.21a3 3 0 0 0-2.305-2.305 3.027 3.027 0 0 0-3.677 2.96c0 .6.176 1.157.479 1.626l-7.075 6.61a.3.3 0 0 1-.386-.039l-1.094-1.122c-.932-.967-2.49-1.016-3.515-.074l-9.473 9.536A2.77 2.77 0 0 0 2 25.437a2.753 2.753 0 0 0 2.744 2.73H25.5a2.747 2.747 0 0 0 2.744-2.745v-9.838a1.1 1.1 0 0 0-2.197 0v9.838a.546.546 0 0 1-.545.547H4.744a.55.55 0 0 1-.547-.541c0-.152.064-.303.21-.44l9.473-9.54z"
    })
  }));
};
DataHubIcon.displayName = 'DataHubIcon';